angular.module("vgresiduos").controller("MovimentationReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/relatorios/movimentacao-residuos");
		};
	}
]);
